export default "__VITE_PUBLIC_ASSET__92c73118__"